import React from 'react';

// GLOBAL COMPONENTS
import Alert from 'core/tools/alert/Alert';
import Sprite from 'core/tools/Sprite';

// MAIN COMPONENT
const InfoAlert = () => (
  <Alert.Dismissable variant="primary" className="p-4 mb-0">
    <div className="d-flex">
      <div className="me-3" style={{ marginTop: -1 }}>
        <Sprite use="info" size="lg" fill="primary" />
      </div>
      <div>
        <h3 className="mb-3">Audit Matching Logic Explained</h3>
        <p className="mb-4">VSD = VIN, Sales # and Deal #.</p>
        <h4 className="h5 mb-2 fw-bolder">Deal Count</h4>
        <ul className="mb-4">
          <li>No Matches - Records will show in here if none, 1 or 2 of the VSD do not match</li>
          <li>Matches - records will show if VSD=1, regardless of gross values</li>
        </ul>
        <h4 className="h5 mb-2 fw-bolder">FE Gross and BE Gross Analysis</h4>
        <ul>
          <li>No Matches - VSD will always match, gross value mismatch</li>
          <li>Matches - VSD will always match, gross value matches</li>
        </ul>
      </div>
    </div>
  </Alert.Dismissable>
);

// EXPORT
export default InfoAlert;
